import { Injectable } from '@angular/core';
import { AddressAutocompleteResult } from '../classes/address-autocomplete-result';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { AddressAutocompletePrediction } from '../classes/address-autocomplete-prediction';

@Injectable({
  providedIn: 'root'
})
export class PlacesService {

  constructor(
    private httpClient: HttpClient,
    private apiService: ApiService
  ) { }

  getPlacePredictions(input: string): Observable<AddressAutocompletePrediction[]> {
    return this.httpClient.post<AddressAutocompletePrediction[]>(`${this.apiService.apiUrl()}/api/customer/places/autocomplete`, { input: input });
  }

  getPlaceByCoordinates(lat: number, long: number): Observable<AddressAutocompleteResult> {
    return this.httpClient.post<AddressAutocompleteResult>(`${this.apiService.apiUrl()}/api/customer/places/reverse`, { lat: lat, long: long });
  }

  getPlaceByPlaceId(place_id: string): Observable<AddressAutocompleteResult> {
    return this.httpClient.post<AddressAutocompleteResult>(`${this.apiService.apiUrl()}/api/customer/places/place`, { place_id: place_id });
  }
}
